// extracted by mini-css-extract-plugin
module.exports = {"shade":"style_shade__3uTv2","modal":"style_modal__d7LoQ","body":"style_body__32x2O","top":"style_top__3xKbH","closeBtn":"style_closeBtn__1QRQw"};